$(document).ready( function() {
	$('.js-typeTags').on('click', 'li', function() {
		const _this = $(this);
		_this.addClass('active').siblings().removeClass('active');
	})
});
